module.exports = __webpack_public_path__ + "static/media/view3.25429ffb.jpg";